import React from 'react'
import Website from './Website'
import Websites from '../Datas/websites.json'

const WebDevBody = () => {
  return (
    <div className='home-body'>
        <div className="top-body">
            <h1>Web-Dev Sector of BlueLoop:</h1>
            <p>"Here, Teenagers who are willing to excell and who are already excelled in the field of Web Development working together and share their knowledge with eachother and build thier dream projects and take thier skillset to the next level! Take a look at the Project that we are working presently!</p>
        </div>
        <div className="content">
            <div className='web-box'>
                {Websites.map((website,index) =><Website
                key={index}
                website={website}
                />)}
            </div>
        </div>
            
    </div>
  )
}

export default WebDevBody